import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import HomePage from "./pages/HomePage";
import ServicePage from "./pages/ServicePage";
import ConsultationPage from "./pages/ConsultationPage";
import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import RefundPolicyPage from "./pages/RefundPolicyPage";
import TermsPage from "./pages/TermsPage";
import GMFLandingPage from "./pages/GMFLandingPage";
import SuperAdsPage from "./pages/SuperAdsPage";
import SocialMediaPage from "./pages/SocialMediaPage";
import TravelHospitalityPage from "./pages/TravelHospitalityPage";
import GulpHookHiringPage from "./pages/GulpHookHiringPage";
import CubeCareersPage from "./pages/CubeCareersPage";
import WhatsAppCommunityPage from "./pages/WhatsAppCommunityPage";

// Layout wrapper to conditionally show Header/Footer
function Layout({ children }) {
  const location = useLocation();
  const isLandingPage = location.pathname === "/gmf" || location.pathname === "/superads" || location.pathname === "/social-media-marketing-plans" || location.pathname === "/travel-hospitality" || location.pathname === "/apply-for-golpohok-editor" || location.pathname === "/joincubeteam" || location.pathname === "/gws-whatsapp-community";
  
  return (
    <div className="min-h-screen bg-[#0a0a0a] relative">
      <div className="noise-overlay" />
      {!isLandingPage && <Header />}
      <main>{children}</main>
      {!isLandingPage && <Footer />}
    </div>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/services/:categoryId" element={<ServicePage />} />
            <Route path="/consultation" element={<ConsultationPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
            <Route path="/refund-policy" element={<RefundPolicyPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/gmf" element={<GMFLandingPage />} />
            <Route path="/superads" element={<SuperAdsPage />} />
            <Route path="/social-media-marketing-plans" element={<SocialMediaPage />} />
            <Route path="/travel-hospitality" element={<TravelHospitalityPage />} />
            <Route path="/apply-for-golpohok-editor" element={<GulpHookHiringPage />} />
            <Route path="/joincubeteam" element={<CubeCareersPage />} />
            <Route path="/gws-whatsapp-community" element={<WhatsAppCommunityPage />} />
          </Routes>
        </Layout>
      </BrowserRouter>
      <Toaster
        position="top-right"
        toastOptions={{
          style: {
            background: "#1a1a1a",
            border: "1px solid rgba(255,255,255,0.06)",
            color: "#fff",
          },
        }}
      />
    </div>
  );
}

export default App;
